(() => {
  const init = () => {
    const root = document.querySelector('.eg-collection-hybrid');
    let nav = root?.querySelector('.eg-hybrid-categories');
    let grid = document.querySelector('[data-section-type="collection"]');
    if (!nav || !grid || nav.dataset.inlineCategories) return;
    nav.dataset.inlineCategories = 'true';
    const closure = 'filter.p.m.custom.product_closure';
    const visor = 'filter.p.m.custom.product_visor_style';
    const feature = 'filter.p.m.custom.product_features';
    const rules = {
      'hats-and-beanies': [],
      fitted: [[closure,'gid://shopify/Metaobject/88616337493'],[closure,'gid://shopify/Metaobject/88405409877']],
      trucker: [[closure,'gid://shopify/Metaobject/88405475413'],[closure,'gid://shopify/Metaobject/88405409877']],
      'classic-snap': [[closure,'gid://shopify/Metaobject/88565940309'],[closure,'gid://shopify/Metaobject/94180802645']],
      'flatbill-snapback': [[visor,'gid://shopify/Metaobject/88405311573']],
      'performance-wear': [[feature,'gid://shopify/Metaobject/87937646677']]
    };
    let links = [...nav.querySelectorAll('a')];
    links.forEach(link => { link.dataset.egCategory = new URL(link.href).pathname.split('/').filter(Boolean).pop(); });
    const pairs = Object.values(rules).flat();
    const clean = params => {
      for (const name of new Set(pairs.map(pair => pair[0]))) {
        const keep = params.getAll(name).filter(value => !pairs.some(pair => pair[0] === name && pair[1] === value));
        params.delete(name); keep.forEach(value => params.append(name,value));
      }
      params.delete('page'); params.delete('section_id'); params.set('view','challenger-hybrid');
      return params;
    };
    const paramsFor = key => {
      const params = clean(new URLSearchParams(location.search));
      (rules[key] || []).forEach(([name,value]) => params.append(name,value));
      return params;
    };
    const sync = () => {
      const current = new URLSearchParams(location.search);
      const selected = links.find(link => {
        const rule = rules[link.dataset.egCategory];
        return rule.length && rule.every(([name,value]) => current.getAll(name).includes(value));
      });
      links.forEach(link => {
        const active = link === selected || (!selected && link.dataset.egCategory === 'hats-and-beanies');
        link.classList.toggle('is-active',active);
        if (active) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
        link.href = location.pathname + '?' + paramsFor(link.dataset.egCategory).toString();
      });
    };
    let timer;
    let loaderObserver;
    const unlock = () => { clearTimeout(timer); nav.removeAttribute('aria-busy'); links.forEach(link => link.removeAttribute('aria-disabled')); sync(); };
    document.addEventListener('click',async event => {
      const link = event.target.closest('a[data-eg-category]');
      if (!link || !link.closest('.eg-hybrid-categories') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      nav = link.closest('.eg-hybrid-categories');
      links = [...nav.querySelectorAll('a[data-eg-category]')];
      if (nav.getAttribute('aria-busy') === 'true') return;
      nav.setAttribute('aria-busy','true'); links.forEach(item => item.setAttribute('aria-disabled','true'));
      let instance;
      for (let attempt = 0; attempt < 40; attempt++) {
        grid = document.querySelector('[data-section-type="collection"]');
        instance = window.Shopify?.theme?.sections?.instances?.find(item => item.container === grid);
        if (instance && typeof instance._renderView === 'function') break;
        await new Promise(resolve => setTimeout(resolve,50));
      }
      if (!instance || typeof instance._renderView !== 'function') { unlock(); return; }
      loaderObserver?.disconnect();
      const currentLoader = grid.querySelector('[data-loading]');
      if (currentLoader) {
        loaderObserver = new MutationObserver(() => { if (!currentLoader.classList.contains('is-active')) unlock(); });
        loaderObserver.observe(currentLoader,{attributes:true,attributeFilter:['class']});
      }
      const params = paramsFor(link.dataset.egCategory).toString();
      nav.setAttribute('aria-busy','true'); links.forEach(item => item.setAttribute('aria-disabled','true'));
      history.pushState({searchParams:params},'',location.pathname+'?'+params);
      window.dispatchEvent(new PopStateEvent('popstate',{state:{searchParams:params}}));
      sync(); timer = setTimeout(unlock,15000);
    });
    window.addEventListener('popstate',sync);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
// Exact collection score/count from the same published Okendo store aggregate.
(() => {
  const tag = 'eg-collection-review-rating';
  if (!window.customElements || customElements.get(tag)) return;
  let aggregatePromise;
  const aggregate = () => aggregatePromise ||= (async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),4000);
    try {
      const response = await fetch('https://api.okendo.io/v1/stores/f501087e-40cc-4115-b48a-7a722c6e9800/review_aggregate',{credentials:'omit',signal:controller.signal});
      if (!response.ok) return null;
      const data = (await response.json())?.reviewAggregate;
      const count = data?.reviewCount;
      const total = data?.reviewRatingValuesTotal;
      if (!Number.isSafeInteger(count) || count < 1 || !Number.isFinite(total) || total < count || total > count*5) return null;
      return {count,average:total/count};
    } catch (_) { return null; }
    finally { clearTimeout(timer); }
  })();
  customElements.define(tag,class extends HTMLElement {
    connectedCallback() {
      aggregate().then(data => {
        if (!this.isConnected) return;
        if (!data) { this.textContent = 'Customer reviews'; this.dataset.reviewStatus = 'unavailable'; return; }
        const stars = document.createElement('span');
        stars.className = 'rating-stars'; stars.setAttribute('aria-hidden','true');
        stars.style.cssText = 'position:relative;display:inline-block;white-space:nowrap;line-height:1';
        const empty = document.createElement('span'); empty.textContent = '★★★★★'; empty.style.opacity = '.25';
        const filled = document.createElement('span'); filled.textContent = '★★★★★';
        filled.style.cssText = `position:absolute;left:0;top:0;overflow:hidden;white-space:nowrap;width:${data.average/5*100}%`;
        stars.append(empty,filled);
        const text = document.createElement('span'); text.className = 'rating-text';
        text.textContent = `${data.average.toFixed(2)}/5 from ${data.count.toLocaleString('en-US')} REAL Reviews`;
        this.replaceChildren(stars,document.createTextNode(' '),text);
        this.dataset.reviewStatus = 'ready'; this.dataset.reviewCount = String(data.count); this.dataset.reviewAverage = String(data.average);
      });
    }
  });
})();